import { getCountryNameFromCode } from "../../../common/util/formatCountryName";
import { storedLocale } from "../../Authentication/util";

type Props = {
  countryCode: string;
};

const DecodeStoredCountryCode = (props: Props) => {
  const { countryCode } = props;
  return <span>{getCountryNameFromCode(countryCode, storedLocale())}</span>;
};

export default DecodeStoredCountryCode;
